import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import Particle from "../../Components/Particle.js";
import MemberCard from "./FeedCard";
import _find from 'lodash/find'

import feeds from './mock'
import FeedCard from "./FeedCard";
import { useParams } from "react-router-dom";
import moment from "moment";


function AchievementDetail() {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const item = _find(feeds, { feedId: id })

  return (
    <div className="project-section w-full">
      <Particle />
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="project-heading">
          {item.headline} <strong className="mainText">  </strong>
        </h1>
        <p className="mainText">
          {moment(item.date,'DD/MM/YYYY').format('LL')}
        </p>
        <div
          className="flex flex-wrap justify-center"
          style={{ paddingBottom: "10px" }}
        >
          <FeedCard
            detailed
            key={item.feedId}
            media={item.media}
            feedId={item.feedId}
            approved={item.approved}
            archived={item.archived}
            created_at={item.created_at}
            date={item.date}
            deleted={item.deleted}
            feedMessage={item.feedMessage}
            headline={item.headline}
            likes={item.likes}
            location={item.location}
            members={item.members}
            updated_at={item.updated_at}
            userId={item.userId}
          />

        </div>
      </div>
    </div>
  );
}

export default AchievementDetail;
